import React from 'react';
import { ResponsiveGrid } from '@alifd/next';
import PageHeader from '@/components/PageHeader';
import VisitorAccessDiscernList from './components/VisitorAccessDiscernList';

const { Cell } = ResponsiveGrid;

const VisitorAccessDiscern = () => (
  <ResponsiveGrid gap={20}>
    <Cell colSpan={12}>
      <PageHeader
        title="訪客辨識管理"
        // description="訪客列表"
        breadcrumbs={[
          {
            name: '訪客門禁',
          },
          {
            name: '訪客辨識管理',
          },
        ]}
      />
    </Cell>

    <Cell colSpan={12}>
      <VisitorAccessDiscernList />
    </Cell>
  </ResponsiveGrid>
);

export default VisitorAccessDiscern;
